import { SearchObject } from "app/common/Model/SearchObject";
import { pagingPatientpayment } from "app/services/PaymentMethod";
import {
  getRevenueDepartmentGroup,
  reportVoucher,
} from "app/services/ReportService";
import { exportVoucherReport } from "app/services/VoucherService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportPaymentStore {
  listData = null;
  dataPayment = null;
  searchReportVoucher = {
    ...new SearchObject(),
    pageSize: 10,
    fromDate: new Date(),
    toDate: new Date(),
    departmentIds: [],
    staffId: null,
    sourceIds: [],
    limitPaymentMethodCodes: [],
  };
  dataChart = null;
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchVoucher = (searchReportVoucher) => {
    this.searchReportVoucher = {
      ...this.searchReportVoucher,
      ...searchReportVoucher,
    };
    this.pagingRevenueDepartmentGroup();
    this.pagingReportVoucher();
  };

  pagingReportVoucher = async () => {
    let {
      departmentIds,
      sourceIds,
      staffId,
      voucherInvoiceTypes,
      orgIds,
      limitPaymentMethodCodes,
      paymentMethodIds,
      ...ortherData
    } = this.searchReportVoucher;
    
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!departmentIds || departmentIds.length === 0) {
      this.listData = null;
      return;
    }
    
    if (staffId) {
      ortherData.staffId = staffId?.id;
    }

    if (Array.isArray(sourceIds)) {
      ortherData.sourceIds = sourceIds.map((x) => x.id);
    }
    if (Array.isArray(departmentIds)) {
      ortherData.departmentIds = departmentIds?.map((x) => x?.id);
    }
    if (Array.isArray(orgIds)) {
      ortherData.orgIds = orgIds?.map((x) => x?.id);
    }
    if (Array.isArray(voucherInvoiceTypes)) {
      ortherData.voucherInvoiceTypes = voucherInvoiceTypes.map((x) => x?.value);
    }
    if (Array.isArray(limitPaymentMethodCodes)) {
      ortherData.limitPaymentMethodCodes = limitPaymentMethodCodes;
    }
    if (Array.isArray(paymentMethodIds)) {
      ortherData.paymentMethodIds = paymentMethodIds.map((x) => x.id);
    }
    return await reportVoucher({ ...ortherData })
      .then(({ data }) => {
        this.listData = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Lấy dữ liệu báo cáo thu chi theo hình thức thanh toán có lỗi"
        );
      });
  };

  pagingReportPayment = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!this.searchReportVoucher.departmentIds || this.searchReportVoucher.departmentIds.length === 0) {
      this.dataPayment = null;
      return;
    }
    
    return await pagingPatientpayment({
      ...this.searchReportVoucher,
      isUse: true,
    })
      .then(({ data }) => {
        this.dataPayment = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Lấy dữ liệu báo cáo thu chi theo hình thức thanh toán có lỗi"
        );
      });
  };

  pagingRevenueDepartmentGroup = async () => {
    let { departmentIds, orgIds, fromDate, toDate, ...ortherData } =
      this.searchReportVoucher;
    
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!departmentIds || departmentIds.length === 0) {
      this.dataChart = null;
      return;
    }
    
    let obj = {
      fromDate,
      toDate,
    };

    if (Array.isArray(departmentIds)) {
      obj.departmentIds = departmentIds?.map((x) => x?.id);
      obj.orgIds = orgIds?.map((x) => x?.id);
    }
    return await getRevenueDepartmentGroup({
      ...obj,
    })
      .then(({ data }) => {
        this.dataChart = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Lấy dữ liệu báo cáo thu chi theo hình thức thanh toán có lỗi"
        );
      });
  };

  handleExportVoucherReport = async (searchObj) => {
    if (!(searchObj?.departmentIds?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    const search = this.normalizeSearchReportVoucher(searchObj);
    try {
      const response = await exportVoucherReport(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BC_THU_CHI_THEO_HTTT.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportVoucher = (rawSearch = {}) => {
    const {
      staffId,
      sourceIds,
      voucherInvoiceTypes,
      departmentIds,
      orgIds,
      limitPaymentMethodCodes,
      paymentMethodIds,
      ...rest
    } = rawSearch;
    return {
      ...rest,
      staffId: staffId?.id || null,
      sourceIds: Array.isArray(sourceIds) ? sourceIds.map((x) => x.id) : [],
      departmentIds: Array.isArray(departmentIds)
        ? departmentIds.map((x) => x.id)
        : [],
      orgIds: Array.isArray(orgIds) ? orgIds.map((x) => x.id) : [],
      voucherInvoiceTypes: voucherInvoiceTypes?.map((x) => x?.value),
      limitPaymentMethodCodes,
      paymentMethodIds: Array.isArray(paymentMethodIds) ? paymentMethodIds.map((x) => x.id) : [],
    };
  };

  resetStore = () => {
    this.listData = null;
    this.searchFee = {
      ...new SearchObject(),
      pageSize: 10,

      fromDate: new Date(),
      toDate: new Date(),
    };
  };
}
